import Swiper from "swiper";

export class GallerySwiper {
    constructor(element, gallery) {
        this.element = element;
        this.gallery = gallery;
    }

    init() {
        this.swiper = new Swiper(this.element, {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            draggable: true,
            autoHeight: true,
            keyboard: {
                enabled:true,
            }

        });

        this.swiper.on('slideChange', () => this.gallery.changeSlide(this.swiper.activeIndex))
    }

    slideTo(index) {
        this.swiper.slideTo(index);
    }
}
